import React from 'react';
import ReactModal from 'react-modal';
import cx from 'classnames';

import { Button } from '@husslehq/ui-library';

import styles from '../../components/Modal/Modal.module.scss';

export type ModalProps = {
  visible: boolean;
  onRequestClose: () => void;
  shouldCloseOnOverlayClick?: boolean;
  shouldCloseOnEsc?: boolean;
  modalClassName?: string;
  overlayClassName?: string;
  showCloseButton?: boolean;
  contentClassName?: string;
};

export const Modal: React.FC<ModalProps> = ({
  visible,
  children,
  onRequestClose,
  shouldCloseOnOverlayClick,
  shouldCloseOnEsc,
  modalClassName,
  overlayClassName,
  showCloseButton,
  contentClassName,
}) => (
  <ReactModal
    isOpen={visible}
    onRequestClose={onRequestClose}
    className={cx(
      modalClassName,
      {
        'remove-inline': !!!modalClassName,
      },
      'react-modal',
    )}
    overlayClassName={overlayClassName ? overlayClassName : 'remove-inline'}
    ariaHideApp={false}
    shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
    shouldCloseOnEsc={shouldCloseOnEsc}
  >
    {showCloseButton && (
      <div className={styles['modal__header']}>
        <Button level="link" onClick={onRequestClose}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            viewBox="0 0 24 24"
            width="24px"
          >
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </Button>
      </div>
    )}
    <div className={`${styles['modal__content']} ${contentClassName ? contentClassName : ''}`}>{children}</div>
  </ReactModal>
);
